import React from "react";

const BaseDropdownContext = React.createContext({});
BaseDropdownContext.displayName = "BaseDropdownContext";

export default BaseDropdownContext;
